import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const ItineraryComponent = ({ packageData = {} }) => {
  const [activeTab, setActiveTab] = useState("itinerary");

  // Handle missing or undefined packageData
  if (!packageData || Object.keys(packageData).length === 0) {
    return <div className="text-red-500 text-center p-4">No package data available</div>;
  }

  // Extract itinerary data dynamically (Days-based structure)
  const itineraryData = Object.keys(packageData)
    .filter((key) => key.startsWith("Day"))
    .map((key) => packageData[key])
    .filter(Boolean); // Remove empty values

  // Handle inclusions & exclusions (splitting by newline if exists)
  const inclusionData = packageData.Inclusions ? packageData.Inclusions.split("\n") : [];
  const exclusionData = packageData.Exclusions ? packageData.Exclusions.split("\n") : [];

  return (
    <div className="w-full h-full mx-auto mt-10">
      {/* Tabs Section */}
      <div className="flex justify-start p-7 rounded-lg bg-[#F7F7F7]">
        {["itinerary", "inclusion", "exclusion"].map((tab) => (
          <div
            key={tab}
            className={`flex items-center cursor-pointer px-4 py-2 rounded-lg transition duration-200 mr-1
              ${activeTab === tab ? 'bg-[#1F4644] text-white' : 'text-gray-700 hover:bg-white'}`}
            onClick={() => setActiveTab(tab)}
          >
            <FontAwesomeIcon
              icon={
                tab === "itinerary"
                  ? faCalendarAlt
                  : tab === "inclusion"
                  ? faCheckCircle
                  : faTimesCircle
              }
              className="mr-2"
            />
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </div>
        ))}
      </div>

      {/* Content Section */}
      <div className="bg-[#F7F7F7] shadow-md rounded-lg mt-4 h-full p-6 overflow-y-auto custom-scrollbar">
        <h2 className="text-2xl font-semibold mb-4">
          {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
        </h2>
        <ul className="list-disc list-inside">
          {activeTab === "itinerary" &&
            itineraryData.map((item, index) => (
              <li key={index} className="mb-2 text-[#1F4644]">{item}</li>
            ))}
          {activeTab === "inclusion" &&
            inclusionData.map((item, index) => (
              <li key={index} className="mb-2 text-[#1F4644]">{item}</li>
            ))}
          {activeTab === "exclusion" &&
            exclusionData.map((item, index) => (
              <li key={index} className="mb-2 text-[#1F4644]">{item}</li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default ItineraryComponent;
